import React from "react";
import "../styles/ServiceComponent.scss";// Aquí puedes añadir estilos personalizados

const ServiceComponent = ({ service, number, subservices,isTwoColumns}) => {
    
  
    return (
      <div className="service-component">
        <div className="service-header">
          <span className="service-name">{service.toUpperCase()}</span>
          <span className="service-number">{String(number).padStart(2, "0")}</span>
        </div>
        <div className={`subservices ${isTwoColumns ? "two-columns" : ""}`}>
          {subservices.map((subservice, index) => (
            <span key={index} className="subservice">
              {subservice}
            </span>
          ))}
          {isTwoColumns && <div className="divider-line"></div>}
        </div>
      </div>
    );
  };
  

export default ServiceComponent;
